import React, { useEffect } from 'react';
import BidDisplay from './BidDisplay';
import Input from '../../theme/forms/Input';
import { updateOrCreateApplication } from '../../../store/calls/applicationData';
import { toggleGlobalLoader , addSuccessAlert } from '../../../store/calls/alertLoadingDispatch';

export const getStatusOptions = (is_biddable=true) => {
    
    if (is_biddable) {
        return [
            {"value": "APPLICATION_CREATED", "display": "Application Created"},
            {"value": "PREPARING_FOR_BID", "display": "Preparing For Bid"},
            {"value": "PREUNDERWRITING", "display": "Preunderwriting"},
            {"value": "READY_FOR_REVIEW", "display": "Ready For Review"},
            {"value": "OUT_FOR_BID", "display": "Out For Bid"},
            {"value": "BIDDING_CLOSED_AWAITING_SELECTION", "display": "Bidding Closed Awaiting Selection"},
            {"value": "BIDDING_CLOSED_NO_BIDS", "display": "Bidding Closed No Bids"},
            {"value": "BID_SELECTED", "display": "Bid Selected"},
            {"value": "APPLICATION_UNDERWAY", "display": "Application Underway"},
            {"value": "FUNDER_REVIEW", "display": "Funder Review"},
            {"value": "STALE", "display": "Inactive"},
            {"value": "CLOSED", "display": "Closed"},
            {"value": "CLOSED_NOT_FUNDED", "display": "Closed Not Funded"}
        ]
    } 
        return [
            {"value": "APPLICATION_CREATED", "display": "Application Created"},
            {"value": "APPLICATION_UNDERWAY", "display": "Application Underway"},
            {"value": "PREUNDERWRITING", "display": "Preunderwriting"},
            {"value": "READY_FOR_REVIEW", "display": "Ready For Review"},
            {"value": "FUNDER_REVIEW", "display": "Funder Review"},
            {"value": "STALE", "display": "Inactive"},
            {"value": "CLOSED", "display": "Closed"},
            {"value": "CLOSED_NOT_FUNDED", "display": "Closed Not Funded"}
        ]
    

}



const getStatusColorClass = (status) => {
    
    const classes = {
        "APPLICATION_CREATED": "has-text-gray",
        "READY_FOR_REVIEW": "has-text-success",
        "PREPARING_FOR_BID": "has-text-success",
        "PREUNDERWRITING": "has-text-success",
        "OUT_FOR_BID": "has-text-success",
        "BIDDING_CLOSED_AWAITING_SELECTION": "has-text-success",
        "BIDDING_CLOSED_NO_BIDS": "has-text-danger",
        "BID_SELECTED": "has-text-success",
        "APPLICATION_UNDERWAY": "has-text-success",
        "FUNDER_REVIEW": "has-text-success",
        "STALE": "has-text-danger",
        "CLOSED": "has-text-danger",
        "CLOSED_NOT_FUNDED": "has-text-danger"
    };

    return classes[ status ] || "has-text-gray"
}

export function AdminStatusDisplay({ id, status, is_biddable, onChange }) {

    const options = getStatusOptions(is_biddable);
    
    return <Input
        type="select"
        value={status}
        options={options}
        inputClasses={`is-medium ${getStatusColorClass(status)}`}
        onChange={(status) => {
            
            updateOrCreateApplication({ id, status });
            addSuccessAlert('Status Updated');
            onChange && onChange(status);
        }}
     />
     
}


export function UserStatusDisplay({ status, is_biddable, onChange }) {

    const options = getStatusOptions(is_biddable);

    useEffect(() => {
        console.log("status", status);
    }, [status])

    
    return (
        <div className='box'>
            <div className="is-flex is-justify-content-space-between">
                <div className={`is-size-5 ${getStatusColorClass(status)}`}>
                    Application Status: <span className='has-text-weight-semibold'>{(options.find(o => o.value === status) || {}).display || 'Application Created'}</span>
                </div>
                {["APPLICATION_CREATED", "PREPARING_FOR_BID", "APPLICATION_UNDERWAY"].includes(status) &&
                    <div className='button is-primary' onClick={() => onChange("READY_FOR_REVIEW")}>
                        Click here to submit your app for review
                    </div>
            }

            {/*  */}
            </div>
        </div>
    )
}
